webpackJsonp([119558142649177],{

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(766);
	
	__webpack_require__(502);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// <!-- <div id="commento"></div> -->
	// <!-- <script src="https://cdn.commento.io/js/commento.js"></script> -->
	
	
	function Template(_ref) {
	    var data = _ref.data;
	    var doc = data.markdownRemark;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'docs-container pure-table pure-table-bordered' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Datasert - ' + doc.frontmatter.title }),
	        _react2.default.createElement(
	            'h2',
	            null,
	            doc.frontmatter.title
	        ),
	        _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: doc.html } })
	    );
	}
	
	var postQuery = exports.postQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-docs-template-jsx-3da5c712eb1390829053.js